import { render } from "./InterviewHeader.vue?vue&type=template&id=5ba6a74b&scoped=true"
import script from "./InterviewHeader.vue?vue&type=script&lang=js"
export * from "./InterviewHeader.vue?vue&type=script&lang=js"

import "./InterviewHeader.vue?vue&type=style&index=0&id=5ba6a74b&lang=scss&scoped=true"
import "./InterviewHeader.vue?vue&type=style&index=1&id=5ba6a74b&lang=scss"

import exportComponent from "/codebuild/output/src766051562/src/medoor-medical-records/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ba6a74b"]])

export default __exports__